import { render, staticRenderFns } from "./CombinenowHeader.vue?vue&type=template&id=5a0a2f11&scoped=true"
import script from "./CombinenowHeader.vue?vue&type=script&lang=js"
export * from "./CombinenowHeader.vue?vue&type=script&lang=js"
import style0 from "./CombinenowHeader.vue?vue&type=style&index=0&id=5a0a2f11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0a2f11",
  null
  
)

export default component.exports